<template>
  <div class="card-analitica main-card mb-3">
    <!-- Info Section -->
    <div class="info-section">
      <div class="icon-box">
        <Icon :name="icon" />
      </div>
      <div class="title-value-wrapper">
        <span class="card-title">{{ title }}</span>
        <div class="value-section">
          <span class="value-label">Valor NF:</span>
          <span class="value-text">R$ {{ value }}</span>
        </div>
      </div>
    </div>
    
    <div class="button-section">
      <b-button 
        variant="outline" 
        class="btn-figma btn-outline-figma mb-2"
        @click="$emit('generate-statement')"
      >
        Gerar Demonstrativo
      </b-button>

      <b-button 
        v-if="hasUploadInvoice" 
        class="btn-figma btn-primary-figma"
        @click="$emit('upload-invoice')"
      >
        Enviar Nota Fiscal
      </b-button>

      <div v-else class="status-info-box">
        <i class="fas fa-info-circle info-icon"></i>
        <span class="info-text">{{ infoText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../../components/icon/Icon.vue';

export default {
  name: "ProductionCard",
  components: {
    Icon,
  },
  props: {
    title: { type: String, required: true },
    value: { type: String, required: true },
    icon: { type: String, default: "" },
    hasUploadInvoice: { type: Boolean, default: true },
    infoText: { type: String, default: "Não é necessário nota fiscal para este item." },
  },
};
</script>

<style lang="scss" scoped>
.card-analitica {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  border: 1px solid #DFDFDF;
}

.main-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }

  .info-section {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;

    .icon-box {
      width: 24px;
      height: 24px;
      color: #007A4A;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title-value-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .card-title {
        font-size: 16px;
        line-height: 24px;
        color: #232428;
      }

      .value-section {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;

        .value-label {
          font-weight: 700;
          font-size: 16px;
          line-height: 19px;
          color: #212529;
        }

        .value-text {
          font-weight: 700;
          font-size: 20px;
          line-height: 24px;
          color: #00423E;
        }
      }
    }
  }

  .button-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 536px;

    @media (max-width: 768px) {
      width: 100%;
      align-items: stretch;
      margin-top: 12px;
    }

    .btn-figma {
      width: 536px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 768px) {
        width: 100%;
      }
    }

    .btn-outline-figma {
      border: 1px solid #007A4A;
      color: #007A4A;
      background: transparent;

      &:hover {
        background-color: #007A4A;
        color: #FFFFFF;
      }
    }

    .btn-primary-figma {
      background: #007A4A;
      border: 1px solid #007A4A;
      color: #FFFFFF;

      &:hover {
        background: #00633b;
      }
    }

    .status-info-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start; /* Alinha ícone e texto à esquerda */
      gap: 8px;
      width: 100%; /* Força o box a ter a mesma largura de 536px do botão */
      padding-top: 4px;

      .info-icon {
        color: #004085;
        font-size: 14px;
      }

      .info-text {
        color: #004085; /* ou a cor exata Muted do Figma */
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>